// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__-Qqwk"};